exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bindingMobile .van-field__control:disabled{color:#323233}", ""]);

// exports
